module.exports = __webpack_public_path__ + "static/img/handle-step-meituan.c3e31c1.png";